import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_STATUS,
  COLUMN_PARENT,
  COLUMN_PARTNER,
  COLUMN_PARTNER_API_ID,
  COLUMN_COUNTRIES,
  COLUMN_APPROXIMATE_USERS,
  COLUMN_LAST_SYNC,
  COLUMN_ACCOUNT,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
} from 'scenes/CustomAudiences/LookalikeAudiences/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_STATUS,
    COLUMN_APPROXIMATE_USERS, //size
    COLUMN_PARENT,
    COLUMN_PARTNER,
    COLUMN_PARTNER_API_ID,
    COLUMN_COUNTRIES,
    COLUMN_ACCOUNT,
    COLUMN_LAST_SYNC,
    COLUMN_CREATED_BY,
    COLUMN_CREATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
